export function customRound(number) {
  if (Number.isInteger(number)) {
    return number;
  } else {
    const floatNum = Number(Number(number).toFixed(2));

    return floatNum;
  }
}
